import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.FirstStartModule.CreateOrganisationPopup.XeroContent', {
    createAndConnect: 'Create and connect',
    createDemo: 'Create and connect a <b>Demo</b> organisation',
    demoHeader: 'Perfect for thorough testing. Your Xero data is not affected.',
    demoDescribe: 'Check how ApprovalMax features work using Xero demo data.',
    xeroName: 'Xero',
    connectToOrganisation: 'Connect your Xero organisation',
    connectToOrgHeader: 'Perfect for a quick start on live Xero data.',
    buttonConnectToOrg: 'Connect to Xero',
});
